import { request } from "services/api/util";

class EmailService {
  getHeaders() {
    return {
      "Accept-Language": "th",
    };
  }

  async saveAuditLogEmail(emails) {
    return request({
      method: "post",
      url: "admin/auditLog/emails",
      data: { emails },
      headers: this.getHeaders(),
    });
  }

  async getAuditLogEmailList() {
    const config = {
      method: "get",
      url: "admin/auditLog/emails",
      headers: this.getHeaders(),
    };
    return request(config);
  }

  async saveCloudWatchEmail(emails) {
    return request({
      method: "post",
      url: "admin/suspiciousNotification/emails",
      data: { emails },
      headers: this.getHeaders(),
    });
  }

  async getCloudWatchEmailList() {
    const config = {
      method: "get",
      url: "admin/suspiciousNotification/emails",
      headers: this.getHeaders(),
    };
    return request(config);
  }
}

export default new EmailService();
